export default Object.freeze({
  // LABEL_SET_TAG_DELETE: 'LABEL_SET_TAG_DELETE',
});
